// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import { persistor } from '../Commonlibs/store';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   ListItemIcon,
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import EditIcon from '@mui/icons-material/Edit';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import MailIcon from '@mui/icons-material/Mail';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import home from '../assets/lob.png';
// import profileIcon from '../assets/iconu.png';
// import logoutIcon from '../assets/logf.png';
// import combinedLogo from '../assets/pdt-logo-white 1.png';
// import proptitle from '../assets/titleprop.png';
// import pdtnav from '../assets/pdtnav.jpg';

// const Navbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const user = useSelector(selectUser);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // ✅ UPDATED: Check if we're on any of the property posting pages
//   const shouldHidePostPropertyButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname === '/add-new-property' ||
//     location.pathname === '/property-details' ||
//     location.pathname === '/price-details' ||
//     location.pathname === '/rent-details';

//   // ✅ UPDATED: Hide Dashboard button on sell-properties and profile-related pages
//   const shouldHideDashboardButton =
//     location.pathname === '/sell-properties' ||
//     location.pathname.startsWith('/sell-properties/') ||
//     location.pathname === '/profile' ||
//     location.pathname.startsWith('/profile/');

//   // Add state for profile data
//   const [profileData, setProfileData] = useState(null);

//   // Add state for logout confirmation dialog
//   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Helper function to parse JWT token
//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split('.')[1]));
//     } catch (e) {
//       console.error('Error parsing JWT token:', e);
//       return null;
//     }
//   };

//   // Add debug logging
//   useEffect(() => {
//     console.log('Auth state check:');
//     console.log('- localStorage token:', localStorage.getItem('auth_token'));
//     console.log('- localStorage user_id:', localStorage.getItem('user_id'));
//     console.log('- localStorage user_email:', localStorage.getItem('user_email'));
//     console.log('- localStorage user_name:', localStorage.getItem('user_name'));
//     console.log('- Redux user:', user);
//     console.log('- Profile data:', profileData);
//   }, [user, profileData]);

//   // Parse token from URL and extract user ID on component mount
//   useEffect(() => {
//     const parseTokenFromURL = () => {
//       try {
//         console.log('Current URL:', window.location.href);
//         // Check if we're on the sell-properties page with a token
//         if (location.pathname === '/sell-properties') {
//           // Extract the token and other params from the URL
//           const urlParams = new URLSearchParams(location.search);
//           const token = urlParams.get('token');
//           const id = urlParams.get('id');
//           const email = urlParams.get('email');
//           const name = urlParams.get('name');

//           console.log('URL Parameters:', { token, id, email, name });

//           if (token && id) {
//             // Parse the JWT to get additional user info if needed
//             const decodedToken = parseJwt(token);
//             console.log('Decoded token:', decodedToken);

//             // Create complete user object with all available info
//             const userToStore = {
//               id: parseInt(id),
//               fullName: name || decodedToken?.name || '',
//               email: email || decodedToken?.email || '',
//               token: token
//             };

//             console.log('Setting user from URL params:', userToStore);

//             // Store in localStorage
//             localStorage.setItem('auth_token', token);
//             localStorage.setItem('user_id', id.toString());
//             localStorage.setItem('user_email', email || '');
//             localStorage.setItem('user_name', name || '');

//             // Let the Redux slice handle localStorage storage
//             dispatch(setUser(userToStore));

//             // Fetch user profile immediately
//             fetchUserProfile();

//             // Clean the URL without refreshing the page
//             window.history.replaceState({}, document.title, '/sell-properties');
//           }
//         }
//       } catch (error) {
//         console.error('Error parsing token from URL:', error);
//       }
//     };

//     parseTokenFromURL();
//   }, [location, dispatch]);

//   // Check for stored token on mount if user is not logged in
//   useEffect(() => {
//     const checkStoredToken = () => {
//       if (!user) {
//         const storedToken = localStorage.getItem('auth_token');
//         const storedId = localStorage.getItem('user_id');
//         const storedEmail = localStorage.getItem('user_email');
//         const storedName = localStorage.getItem('user_name');

//         if (storedToken && storedId) {
//           const userToStore = {
//             id: parseInt(storedId),
//             email: storedEmail || '',
//             fullName: storedName || '',
//             token: storedToken
//           };
//           dispatch(setUser(userToStore));
//         }
//       }
//     };

//     checkStoredToken();
//   }, [user, dispatch]);

//   // UPDATED: Fetch user profile data with complete user details
//   const fetchUserProfile = async () => {
//     try {
//       const storedToken = localStorage.getItem('auth_token');
//       const storedId = localStorage.getItem('user_id');

//       console.log('Fetching profile with stored credentials:', {
//         storedId,
//         tokenExists: !!storedToken,
//         reduxUser: user
//       });

//       // Use either redux user or localStorage values
//       const id = user?.id || storedId;
//       const token = user?.token || storedToken;

//       if (id && token) {
//         console.log(`Making API call to fetch user ${id} profile`);
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
//           {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (!response.ok) {
//           console.error('Profile fetch failed with status:', response.status);
//           return;
//         }

//         const data = await response.json();
//         console.log('Profile API response:', data);

//         if (data.status === "SUCCESS" && data.result) {
//           setProfileData(data.result);

//           // Update Redux with complete user details from API
//           const updatedUser = {
//             id: parseInt(id),
//             token: token,
//             fullName: data.result.full_name,
//             email: data.result.email_id,
//             contactNumber: data.result.contact_number,
//             profileImage: data.result.profile_image,
//             authProvider: data.result.auth_provider,
//             googleId: data.result.google_id,
//             location: data.result.location,
//             occupation: data.result.occupation,
//             professionalTitle: data.result.professional_title,
//             companyName: data.result.company_name,
//             yearsOfExperience: data.result.years_of_experience,
//             licenseNumber: data.result.license_number,
//             bio: data.result.bio,
//             website: data.result.website,
//             linkedin: data.result.linkedin,
//             facebook: data.result.facebook,
//           };

//           console.log('Updating user in Redux with:', updatedUser);

//           // Use appropriate action based on auth provider
//           if (data.result.auth_provider === 'google') {
//             dispatch(setGoogleUser(updatedUser));
//           } else {
//             dispatch(setUser(updatedUser));
//           }

//           // Update localStorage with fresh data
//           localStorage.setItem('user_name', data.result.full_name);
//           localStorage.setItem('user_email', data.result.email_id);
//         } else {
//           console.error('Failed to get valid profile data:', data);
//         }
//       } else {
//         console.warn('Missing user ID or token, cannot fetch profile');
//       }
//     } catch (err) {
//       console.error('Error fetching profile:', err);
//     }
//   };

//   useEffect(() => {
//     // Only fetch if we don't have profile data yet
//     if (user?.id && user?.token && !profileData) {
//       fetchUserProfile();
//     }
//   }, [user?.id, user?.token, profileData, dispatch]);

//   // Debug user state
//   useEffect(() => {
//     console.log('Current user in Redux:', user);
//     console.log('Profile data:', profileData);
//   }, [user, profileData]);

//   // Open logout confirmation dialog
//   const openLogoutDialog = () => {
//     setLogoutDialogOpen(true);
//     setDrawerOpen(false); // Close drawer when opening dialog
//   };

//   // Close logout confirmation dialog
//   const closeLogoutDialog = () => {
//     setLogoutDialogOpen(false);
//   };

//   const handleLogout = async () => {
//   try {
//     console.log('🚪 Starting logout process...');
    
//     // 1. Clear local component state
//     setProfileData(null);
    
//     // 2. Dispatch logout to Redux
//     dispatch(logout());
    
//     // 3. Purge persistor
//     await persistor.purge();
//     await persistor.flush();
    
//     // 4. Clear ALL localStorage and sessionStorage
//     localStorage.clear();
//     sessionStorage.clear();
    
//     // 5. Close dialog
//     closeLogoutDialog();
    
//     // 6. Navigate to home
//     navigate('/', { replace: true });
    
//     // 7. Optional: Force reload to ensure clean state
//     setTimeout(() => {
//       window.location.href = '/';
//     }, 100);
    
//     console.log('✅ Logout completed successfully');
//   } catch (error) {
//     console.error('❌ Error during logout:', error);
//     // Force navigation even if error occurs
//     localStorage.clear();
//     sessionStorage.clear();
//     window.location.href = '/';
//   }
// };

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
//     setDrawerOpen(open);
//   };

//   // ✅ UPDATED: Handle List Property button click - navigate to add-new-property
//  // In Navbar.jsx, modify the handleListPropertyClick function:

// const handleListPropertyClick = () => {
//   setDrawerOpen(false);
//   if (!user) {
//     navigate('/login');
//   } else {
//     // ✅ Clear all property form data when clicking "Post Property"
//     clearAllPropertyFormData();
//     navigate('/add-new-property');
//   }
// };

// // ✅ Add this helper function to clear all form data
// const clearAllPropertyFormData = () => {
//   // Clear AddNewProperty data
//   localStorage.removeItem('propertyType');
//   localStorage.removeItem('category');
//   localStorage.removeItem('propertyLocation');
  
//   // Clear PropertyDetails data
//   localStorage.removeItem('propertyDetailsFormState');
  
//   // Clear PriceDetails data
//   localStorage.removeItem('price_askingPrice');
//   localStorage.removeItem('price_currency');
//   localStorage.removeItem('price_constructionStatus');
//   localStorage.removeItem('price_negotiable');
  
//   // Clear RentDetails data
//   localStorage.removeItem('rent_monthlyRent');
//   localStorage.removeItem('rent_currency');
//   localStorage.removeItem('rent_availableFrom');
//   localStorage.removeItem('rent_securityDeposit');
// };

//   // ✅ NEW: Handle Dashboard button click
//   const handleDashboardClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties');
//   };

//   // ✅ NEW: Handle Profile Icon click - navigate to edit profile
//   const handleProfileClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/edit');
//   };

//   // ✅ NEW: Handle My Properties click
//   const handleMyPropertiesClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/seeAll');
//   };

//   // ✅ NEW: Handle Inbox click
//   const handleInboxClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/inbox');
//   };

//   // ✅ NEW: Handle Transactions click
//   const handleTransactionsClick = () => {
//     setDrawerOpen(false);
//     navigate('/sell-properties/transactions');
//   };

//   // ✅ NEW: Handle My Activity click
//   const handleMyActivityClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile');
//   };

//   // ✅ NEW: Handle Wishlist click
//   const handleWishlistClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/wishlist');
//   };

//   // ✅ NEW: Handle Recent Searches click
//   const handleRecentSearchesClick = () => {
//     setDrawerOpen(false);
//     navigate('/profile/recent-searches');
//   };

//   const drawerContent = (
//     <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
//       <List>
//         {!user ? (
//           <ListItem button component={Link} to="/login" onClick={() => setDrawerOpen(false)}>
//             <ListItemText
//               primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//               primary="Sign In"
//             />
//           </ListItem>
//         ) : (
//           <>
//             {/* ✅ UPDATED: Show ALL Sidebar Items in Mobile Menu on ALL PAGES */}
//             {/* Dashboard */}
//             <ListItem button onClick={handleDashboardClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Dashboard"
//               />
//             </ListItem>

//             {/* Edit Profile */}
//             <ListItem button onClick={handleProfileClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Edit Profile"
//               />
//             </ListItem>

//             {/* My Properties */}
//             <ListItem button onClick={handleMyPropertiesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Properties"
//               />
//             </ListItem>

//             {/* Inbox */}
//             <ListItem button onClick={handleInboxClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Inbox"
//               />
//             </ListItem>

//             {/* Transactions */}
//             <ListItem button onClick={handleTransactionsClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Transactions"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             {/* My Activity */}
//             <ListItem button onClick={handleMyActivityClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="My Activity"
//               />
//             </ListItem>

//             {/* Wishlist */}
//             <ListItem button onClick={handleWishlistClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Wishlist"
//               />
//             </ListItem>

//             {/* Recent Searches */}
//             <ListItem button onClick={handleRecentSearchesClick}>
//               <ListItemIcon sx={{ minWidth: '40px' }}>
//                 <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
//               </ListItemIcon>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Recent Searches"
//               />
//             </ListItem>

//             <Divider sx={{ my: 1 }} />

//             {/* Logout button - always visible for logged-in users */}
//             <ListItem button onClick={openLogoutDialog}>
//               <ListItemText
//                 primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
//                 primary="Logout"
//               />
//             </ListItem>
//           </>
//         )}

//         <ListItem>
//           {/* ✅ UPDATED: Use new condition */}
//           {!shouldHidePostPropertyButton && (
//             <Button
//               variant="contained"
//               fullWidth
//               sx={{ bgcolor: '#ffc107', color: '#fff' }}
//               onClick={handleListPropertyClick}
//             >
//               Post Property
//             </Button>
//           )}
//         </ListItem>
//       </List>
//     </Box>
//   );

//   // Use profileData.full_name if available
//   const userName = profileData?.full_name || user?.fullName || '';

//   return (
//     <Box sx={{ fontFamily: 'Outfit' }}>
//       <AppBar
//         position="fixed"
//         elevation={3}
//         sx={{
//           backgroundColor: '#fff',
//           px: 2,
//           py: 1,
//           transition: 'background-color 0.3s ease, border-radius 0.3s ease',
//           borderRadius: scrolled ? '0 0 50px 50px' : 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           color: '#000',
//           minHeight: '64px',
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             overflow: 'hidden',
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//             <Box
//               sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
//               onClick={() => navigate('/')}
//             >
//               <img src={home} alt="logo" style={{ height: 38 }} />
//               <img src={proptitle} alt="logo" style={{ height: 18, width: 250 }} />
//             </Box>
//           </Box>

//           <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
//             {user ? (
//               <>
//                 <Typography noWrap sx={{ color: '#000' }}>
//                   Hello,
//                   <span style={{ color: '#000', fontWeight: 600 }}>
//                     {userName || 'User'}
//                   </span>
//                 </Typography>

//                 <Box
//                   onClick={handleProfileClick}
//                   sx={{
//                     backgroundColor: '#ffc107',
//                     borderRadius: '50%',
//                     width: 56,
//                     height: 56,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     cursor: 'pointer',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <img
//                     src={profileData?.profile_image || profileIcon}
//                     alt="user"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover'
//                     }}
//                     onError={(e) => {
//                       e.target.src = profileIcon;
//                     }}
//                   />
//                 </Box>

//                 {/* ✅ UPDATED: Use new condition */}
//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     variant="contained"
//                     sx={{ bgcolor: '#ffc107', color: '#fff', textTransform: 'none', fontWeight: 500 }}
//                     onClick={handleListPropertyClick}
//                   >
//                     Post Property
//                   </Button>
//                 )}

//                 {/* ✅ UPDATED: Hide Dashboard Button on sell-properties and profile pages */}
//                 {!shouldHideDashboardButton && (
//                   <Button
//                     variant="contained"
//                     startIcon={<DashboardIcon />}
//                     onClick={handleDashboardClick}
//                     sx={{
//                       color: '#fff',
//                       backgroundColor: '#ffc107',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       '&:hover': {
//                         backgroundColor: '#ffc107',
//                       }
//                     }}
//                   >
//                     Dashboard
//                   </Button>
//                 )}

//                 <Button
//                   onClick={openLogoutDialog}
//                   sx={{
//                     color: '#fff',
//                     backgroundColor: '#ffc107',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     textTransform: 'none',
//                     fontWeight: 500,
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </>
//             ) : (
//               <>
//                 <Button
//                   component={Link}
//                   to="/login"
//                   sx={{ color: '#ffc107', fontWeight: 500 }}
//                 >
//                   Sign In
//                 </Button>

//                 {/* ✅ UPDATED: Use new condition */}
//                 {!shouldHidePostPropertyButton && (
//                   <Button
//                     variant="contained"
//                     sx={{ bgcolor: '#ffc107', color: '#fff' }}
//                     onClick={handleListPropertyClick}
//                   >
//                     Post Property
//                   </Button>
//                 )}
//               </>
//             )}
//           </Box>

//           <IconButton
//             onClick={toggleDrawer(true)}
//             sx={{ display: { md: 'none' }, color: 'inherit' }}
//           >
//             <MenuIcon />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//         {drawerContent}
//       </Drawer>

//       <Toolbar />

//       {/* Logout Confirmation Dialog */}
//       <Dialog
//         open={logoutDialogOpen}
//         onClose={closeLogoutDialog}
//         aria-labelledby="logout-dialog-title"
//         aria-describedby="logout-dialog-description"
//       >
//         <DialogTitle id="logout-dialog-title">
//           Logout Confirmation
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="logout-dialog-description">
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleLogout} color="primary" variant="contained">
//             Logout
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, logout, setUser, setGoogleUser } from '../Commonlibs/userSlice';
import { persistor } from '../Commonlibs/store';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  ListItemIcon,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EditIcon from '@mui/icons-material/Edit';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MailIcon from '@mui/icons-material/Mail';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import home from '../assets/lob.png';
import profileIcon from '../assets/iconu.png';
import logoutIcon from '../assets/logf.png';
import combinedLogo from '../assets/pdt-logo-white 1.png';
import proptitle from '../assets/titleprop.png';
import pdtnav from '../assets/pdtnav.jpg';

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const shouldHidePostPropertyButton =
    location.pathname === '/sell-properties' ||
    location.pathname === '/add-new-property' ||
    location.pathname === '/property-details' ||
    location.pathname === '/amenities' ||
    location.pathname === '/price-details' ||
    location.pathname === '/rent-details';

  const shouldHideDashboardButton =
    location.pathname === '/sell-properties' ||
    location.pathname.startsWith('/sell-properties/') ||
    location.pathname === '/profile' ||
    location.pathname.startsWith('/profile/');

  const [profileData, setProfileData] = useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      console.error('Error parsing JWT token:', e);
      return null;
    }
  };

  useEffect(() => {
    console.log('Auth state check:');
    console.log('- localStorage token:', localStorage.getItem('auth_token'));
    console.log('- localStorage user_id:', localStorage.getItem('user_id'));
    console.log('- localStorage user_email:', localStorage.getItem('user_email'));
    console.log('- localStorage user_name:', localStorage.getItem('user_name'));
    console.log('- Redux user:', user);
    console.log('- Profile data:', profileData);
  }, [user, profileData]);

  useEffect(() => {
    const parseTokenFromURL = () => {
      try {
        console.log('Current URL:', window.location.href);
        
        if (location.pathname === '/sell-properties') {
          const urlParams = new URLSearchParams(location.search);
          const token = urlParams.get('token');
          const id = urlParams.get('id');
          const email = urlParams.get('email');
          const name = urlParams.get('name');

          console.log('URL Parameters:', { token, id, email, name });

          if (token && id) {
            const decodedToken = parseJwt(token);
            console.log('Decoded token:', decodedToken);

            const userToStore = {
              id: parseInt(id),
              fullName: name || decodedToken?.name || '',
              email: email || decodedToken?.email || '',
              token: token
            };

            console.log('Setting user from URL params:', userToStore);

            localStorage.setItem('auth_token', token);
            localStorage.setItem('user_id', id.toString());
            localStorage.setItem('user_email', email || '');
            localStorage.setItem('user_name', name || '');

            dispatch(setUser(userToStore));
            fetchUserProfile();
            window.history.replaceState({}, document.title, '/sell-properties');
          }
        }
      } catch (error) {
        console.error('Error parsing token from URL:', error);
      }
    };

    parseTokenFromURL();
  }, [location, dispatch]);

  useEffect(() => {
    const checkStoredToken = () => {
      if (!user) {
        const storedToken = localStorage.getItem('auth_token');
        const storedId = localStorage.getItem('user_id');
        const storedEmail = localStorage.getItem('user_email');
        const storedName = localStorage.getItem('user_name');

        if (storedToken && storedId) {
          const userToStore = {
            id: parseInt(storedId),
            email: storedEmail || '',
            fullName: storedName || '',
            token: storedToken
          };
          dispatch(setUser(userToStore));
        }
      }
    };

    checkStoredToken();
  }, [user, dispatch]);

  const fetchUserProfile = async () => {
    try {
      const storedToken = localStorage.getItem('auth_token');
      const storedId = localStorage.getItem('user_id');

      console.log('Fetching profile with stored credentials:', {
        storedId,
        tokenExists: !!storedToken,
        reduxUser: user
      });

      const id = user?.id || storedId;
      const token = user?.token || storedToken;

      if (id && token) {
        console.log(`Making API call to fetch user ${id} profile`);
        const response = await fetch(
          `https://propertydealstalk.com/api/users/getUserById?user_id=${id}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) {
          console.error('Profile fetch failed with status:', response.status);
          return;
        }

        const data = await response.json();
        console.log('Profile API response:', data);

        if (data.status === "SUCCESS" && data.result) {
          setProfileData(data.result);

          const updatedUser = {
            id: parseInt(id),
            token: token,
            fullName: data.result.full_name,
            email: data.result.email_id,
            contactNumber: data.result.contact_number,
            profileImage: data.result.profile_image,
            authProvider: data.result.auth_provider,
            googleId: data.result.google_id,
            location: data.result.location,
            occupation: data.result.occupation,
            professionalTitle: data.result.professional_title,
            companyName: data.result.company_name,
            yearsOfExperience: data.result.years_of_experience,
            licenseNumber: data.result.license_number,
            bio: data.result.bio,
            website: data.result.website,
            linkedin: data.result.linkedin,
            facebook: data.result.facebook,
          };

          console.log('Updating user in Redux with:', updatedUser);

          if (data.result.auth_provider === 'google') {
            dispatch(setGoogleUser(updatedUser));
          } else {
            dispatch(setUser(updatedUser));
          }

          localStorage.setItem('user_name', data.result.full_name);
          localStorage.setItem('user_email', data.result.email_id);
        } else {
          console.error('Failed to get valid profile data:', data);
        }
      } else {
        console.warn('Missing user ID or token, cannot fetch profile');
      }
    } catch (err) {
      console.error('Error fetching profile:', err);
    }
  };

  useEffect(() => {
    if (user?.id && user?.token) {
      fetchUserProfile();
    }
  }, [user?.id, user?.token]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'profile_updated' && e.newValue === 'true') {
        console.log('Profile update detected, refreshing navbar data...');
        fetchUserProfile();
        localStorage.removeItem('profile_updated');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    const intervalId = setInterval(() => {
      if (localStorage.getItem('profile_updated') === 'true') {
        console.log('Profile update detected (same tab), refreshing navbar data...');
        fetchUserProfile();
        localStorage.removeItem('profile_updated');
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, [user?.id, user?.token]);

  useEffect(() => {
    console.log('Current user in Redux:', user);
    console.log('Profile data:', profileData);
  }, [user, profileData]);

  const openLogoutDialog = () => {
    setLogoutDialogOpen(true);
    setDrawerOpen(false);
  };

  const closeLogoutDialog = () => {
    setLogoutDialogOpen(false);
  };

  const handleLogout = async () => {
    try {
      console.log('🚪 Starting logout process...');
      setProfileData(null);
      dispatch(logout());
      await persistor.purge();
      await persistor.flush();
      localStorage.clear();
      sessionStorage.clear();
      closeLogoutDialog();
      navigate('/', { replace: true });
      setTimeout(() => {
        window.location.href = '/';
      }, 100);
      console.log('✅ Logout completed successfully');
    } catch (error) {
      console.error('❌ Error during logout:', error);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setDrawerOpen(open);
  };

  // ✅ FIXED: Just navigate, let AddNewProperty handle the dialog
  const handleListPropertyClick = () => {
    setDrawerOpen(false);
    
    if (!user) {
      navigate('/login');
      return;
    }

    // ✅ Just navigate - AddNewProperty will show dialog if needed
    navigate('/add-new-property');
  };

  const handleDashboardClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties');
  };

  const handleProfileClick = () => {
    setDrawerOpen(false);
    navigate('/profile/edit');
  };

  const handleMyPropertiesClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties/seeAll');
  };

  const handleInboxClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties/inbox');
  };

  const handleTransactionsClick = () => {
    setDrawerOpen(false);
    navigate('/sell-properties/transactions');
  };

  const handleMyActivityClick = () => {
    setDrawerOpen(false);
    navigate('/profile');
  };

  const handleWishlistClick = () => {
    setDrawerOpen(false);
    navigate('/profile/wishlist');
  };

  const handleRecentSearchesClick = () => {
    setDrawerOpen(false);
    navigate('/profile/recent-searches');
  };

  const drawerContent = (
    <Box sx={{ width: 250, height: '100%', bgcolor: '#fff' }}>
      <List>
        {!user ? (
          <ListItem button component={Link} to="/login" onClick={() => setDrawerOpen(false)}>
            <ListItemText
              primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
              primary="Sign In"
            />
          </ListItem>
        ) : (
          <>
            <ListItem button onClick={handleDashboardClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <DashboardIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Dashboard"
              />
            </ListItem>

            <ListItem button onClick={handleProfileClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <EditIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Edit Profile"
              />
            </ListItem>

            <ListItem button onClick={handleMyPropertiesClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="My Properties"
              />
            </ListItem>

            <ListItem button onClick={handleInboxClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <MailIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Inbox"
              />
            </ListItem>

            <ListItem button onClick={handleTransactionsClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <SwapHorizIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Transactions"
              />
            </ListItem>

            <Divider sx={{ my: 1 }} />

            <ListItem button onClick={handleMyActivityClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <PersonIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="My Activity"
              />
            </ListItem>

            <ListItem button onClick={handleWishlistClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <FavoriteIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Wishlist"
              />
            </ListItem>

            <ListItem button onClick={handleRecentSearchesClick}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <SearchIcon sx={{ color: '#1A2B4B', fontSize: 20 }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Recent Searches"
              />
            </ListItem>

            <Divider sx={{ my: 1 }} />

            <ListItem button onClick={openLogoutDialog}>
              <ListItemText
                primaryTypographyProps={{ sx: { color: '#4B5563', fontWeight: 500 } }}
                primary="Logout"
              />
            </ListItem>
          </>
        )}
        <ListItem>
          {!shouldHidePostPropertyButton && (
            <Button
              variant="contained"
              fullWidth
              sx={{ bgcolor: '#ffc107', color: '#fff' }}
              onClick={handleListPropertyClick}
            >
              Post Property
            </Button>
          )}
        </ListItem>
      </List>
    </Box>
  );

  const userName = user?.fullName || profileData?.full_name || '';
  const userProfileImage = user?.profileImage || profileData?.profile_image || profileIcon;

  return (
    <Box sx={{ fontFamily: 'Outfit' }}>
      <AppBar
        position="fixed"
        elevation={3}
        sx={{
          backgroundColor: '#fff',
          px: 2,
          py: 1,
          transition: 'background-color 0.3s ease, border-radius 0.3s ease',
          borderRadius: scrolled ? '0 0 50px 50px' : 0,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
          color: '#000',
          minHeight: '64px',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            overflow: 'hidden',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
              onClick={() => navigate('/')}
            >
              <img src={home} alt="logo" style={{ height: 38 }} />
              <img src={proptitle} alt="logo" style={{ height: 18, width: 250 }} />
            </Box>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
            {user ? (
              <>
                <Typography noWrap sx={{ color: '#000' }}>
                  Hello,
                  <span style={{ color: '#000', fontWeight: 600 }}>
                    {userName || 'User'}
                  </span>
                </Typography>

                <Box
                  onClick={handleProfileClick}
                  sx={{
                    backgroundColor: '#ffc107',
                    borderRadius: '50%',
                    width: 56,
                    height: 56,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    key={userProfileImage}
                    src={userProfileImage}
                    alt="user"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      e.target.src = profileIcon;
                    }}
                  />
                </Box>

                {!shouldHidePostPropertyButton && (
                  <Button
                    variant="contained"
                    sx={{ bgcolor: '#ffc107', color: '#fff', textTransform: 'none', fontWeight: 500 }}
                    onClick={handleListPropertyClick}
                  >
                    Post Property
                  </Button>
                )}

                {!shouldHideDashboardButton && (
                  <Button
                    variant="contained"
                    startIcon={<DashboardIcon />}
                    onClick={handleDashboardClick}
                    sx={{
                      color: '#fff',
                      backgroundColor: '#ffc107',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      textTransform: 'none',
                      fontWeight: 500,
                      '&:hover': {
                        backgroundColor: '#ffc107',
                      }
                    }}
                  >
                    Dashboard
                  </Button>
                )}

                <Button
                  onClick={openLogoutDialog}
                  sx={{
                    color: '#fff',
                    backgroundColor: '#ffc107',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                  }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  component={Link}
                  to="/login"
                  sx={{ color: '#ffc107', fontWeight: 500 }}
                >
                  Sign In
                </Button>

                {!shouldHidePostPropertyButton && (
                  <Button
                    variant="contained"
                    sx={{ bgcolor: '#ffc107', color: '#fff' }}
                    onClick={handleListPropertyClick}
                  >
                    Post Property
                  </Button>
                )}
              </>
            )}
          </Box>

          <IconButton
            onClick={toggleDrawer(true)}
            sx={{ display: { md: 'none' }, color: 'inherit' }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerContent}
      </Drawer>

      <Toolbar />

      {/* Logout Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={closeLogoutDialog}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">
          Logout Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeLogoutDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleLogout} color="primary" variant="contained">
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Navbar;